import styled from 'styled-components'
import Text from '@/components/common/Text'
import classNames from 'classnames'
import Button from '@/components/ui/Button'
import { device } from '@/common/constants/device'
import { useTranslations } from 'next-intl'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  width: 100%;
  margin-top: 12px;
`

const FeedbackModalButton = styled(Button)`
  width: 100%;
`

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    @media ${device.tablet} {
        flex-wrap: nowrap;
    }
}
`

const Item = styled.div`
  width: 54px;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;

  @media ${device.tablet} {
    width: 90px;
  }
`
const ButtonStyled = styled.button`
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid var(--purple);
  background: transparent;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #b2b1f1;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  padding: 0.5rem;
  box-sizing: border-box;
  outline: none;
  user-select: none;
  position: relative;

  &:hover {
    background: rgba(231, 235, 255, 0.6);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(1);
    background: rgba(231, 235, 255, 1);
  }

  &.selected {
    color: var(--purple);
    transform: scale(1.1);
    background: rgba(231, 235, 255, 1);
  }

  &:hover::after {
    opacity: 1;
  }
`

const StepOne = ({ formData, setFormData, handleNextStep }) => {
  const t = useTranslations('creatives')

  const isSelectedExperience = (value) => {
    return classNames({
      selected: formData.experience === value,
    })
  }

  const isSelectedRating = (value) => {
    return classNames({
      selected: formData.searchRating === value,
    })
  }

  return (
    <Wrapper>
      <>
        <Text size="16">{t('experienceRatingQuestion')}</Text>
        <Container>
          {[...Array(10)].map((_, index) => {
            const value = index + 1
            return (
              <Item key={value}>
                <ButtonStyled
                  className={isSelectedExperience(value)}
                  onClick={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      experience: value,
                    }))
                  }
                >
                  {value}
                </ButtonStyled>
              </Item>
            )
          })}
        </Container>
      </>
      <>
        <Text size="16">{t('searchPerformanceQuestion')}</Text>
        <Container>
          {[...Array(10)].map((_, index) => {
            const value = index + 1
            return (
              <Item key={value}>
                <ButtonStyled
                  className={isSelectedRating(value)}
                  onClick={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      searchRating: value,
                    }))
                  }
                >
                  {value}
                </ButtonStyled>
              </Item>
            )
          })}
        </Container>
      </>
      <FeedbackModalButton filled onClick={handleNextStep}>
        {t('btnContinue')}
      </FeedbackModalButton>
    </Wrapper>
  )
}
export default StepOne
